import { QueryTypeName } from './query-type';

export function isTradeFileDetails(queryTypeName?: string): boolean {
    return queryTypeName === QueryTypeName.TRADE_FILE_DETAILS;
}
